const SEPARATORS = /[\s,;]+/;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** One well-formed address. */
export const isValidEmail = (value) => EMAIL_RE.test(value);

/** True when `value` holds more than one address or a separator that confirms one. */
export const hasEmailSeparator = (value) => /[\s,;]/.test(value.trim());

/**
 * Split free text (typed or pasted) into addresses.
 *
 * @param {string} raw
 * @returns {{ valid: string[], invalid: string[] }} Lowercased, de-duplicated within the input.
 */
export const parseEmails = (raw) => {
  const valid = [];
  const invalid = [];
  const seen = new Set();
  String(raw ?? '')
    .split(SEPARATORS)
    .map((token) => token.trim())
    .filter(Boolean)
    .forEach((token) => {
      const email = token.toLowerCase();
      if (seen.has(email)) return;
      seen.add(email);
      if (EMAIL_RE.test(email)) valid.push(email);
      else invalid.push(token);
    });
  return { valid, invalid };
};
